import React, { useState, useEffect } from 'react';
import Amplify, { Storage } from 'aws-amplify';

Amplify.configure({
  Auth: {
    identityPoolId: "us-west-2:3aa9e1dd-d9fd-4d5c-bffc-13aee925b4b9",
    userPoolWebClientId: "sec9n0vlq226j4f6obo81v8e1hucldpm4itqlqlnhpf4snpf09a",
    region: "us-west-2",
  },
  Storage: {
    AWSS3: {
      bucket: "sneakercrushios16892e7334d44b5f9e6936b5b6a5af3c170356-dev",
      region: "us-west-2",
      defaultAccessLevel: "guest",
    }
  }
});

const DEFAULT_IMG = "https://i.stack.imgur.com/y9DpT.jpg";

const isHttpUrl = (value) =>
  typeof value === 'string' && /^https?:\/\//i.test(value.trim());

const ImgLink = ({ imageStyle, link }) => {
  const [srcLink, setSrcLink] = useState(DEFAULT_IMG);

  useEffect(() => {
    if (!link) {
      setSrcLink(DEFAULT_IMG);
      return;
    }
    if (isHttpUrl(link)) {
      setSrcLink(link.trim());
      return;
    }
    let cancelled = false;
    Storage.get(link)
      .then((newLink) => {
        if (!cancelled) setSrcLink(newLink);
      })
      .catch(() => {
        if (!cancelled) setSrcLink(DEFAULT_IMG);
      });
    return () => { cancelled = true; };
  }, [link]);

  return (
    <div>
      <img alt="Post img" style={imageStyle} src={srcLink} onError={(e) => e.target.setAttribute("src", DEFAULT_IMG)} />
    </div>
  );
}

export default ImgLink;